class DetailsDisclosure extends HTMLElement {
	constructor() {
		super()
		this.mainDetailsToggle = this.querySelector('details')
		this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling
		this.summary = this.mainDetailsToggle.querySelector('summary')
		this.closeTimer = null
		this.hoverDelay = 300
		this.allowSummaryLinkSelector = 'a.ec-header-menu-top-link[href]'

		this.summary.addEventListener('mouseenter', this.onMouseEnter.bind(this))
		this.summary.addEventListener('mouseleave', this.onMouseLeave.bind(this))
		if (this.content) {
			this.content.addEventListener('mouseenter', this.onContentEnter.bind(this))
			this.content.addEventListener('mouseleave', this.onMouseLeave.bind(this))
		}

		this.summary.addEventListener('click', (e) => {
			if (e.target.closest(this.allowSummaryLinkSelector)) return
			e.preventDefault()
		})

		this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this))
		this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this))
	}

	onMouseEnter() {
		if (this.closeTimer) {
			clearTimeout(this.closeTimer)
			this.closeTimer = null
		}
		this.open()
	}

	onMouseLeave() {
		this.closeTimer = setTimeout(() => {
			this.close()
			this.closeTimer = null
		}, this.hoverDelay)
	}

	onContentEnter() {
		if (this.closeTimer) {
			clearTimeout(this.closeTimer)
			this.closeTimer = null
		}
	}

	onFocusOut() {
		setTimeout(() => {
			if (!this.contains(document.activeElement)) this.close()
		})
	}

	onToggle() {
		if (!this.animations) this.animations = this.content.getAnimations()

		if (this.mainDetailsToggle.hasAttribute('open')) {
			this.animations.forEach((animation) => animation.play())
		} else {
			this.animations.forEach((animation) => animation.cancel())
		}
	}

	open() {
		this.mainDetailsToggle.setAttribute('open', '')
		this.summary.setAttribute('aria-expanded', true)
	}

	close() {
		if (this.closeTimer) {
			clearTimeout(this.closeTimer)
			this.closeTimer = null
		}
		this.mainDetailsToggle.removeAttribute('open')
		this.summary.setAttribute('aria-expanded', false)
	}
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.openDelay = 250;
    this.openTimer = null;
    this.hoverDelay = 900;
    this.setupHeaderLeaveListener();
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  setupHeaderLeaveListener() {
    const headerWrapper = this.closest('.header-wrapper') || document.querySelector('.header-wrapper');
    if (!headerWrapper || headerWrapper.dataset.headerLeaveBound === 'true') return;
    headerWrapper.dataset.headerLeaveBound = 'true';
    headerWrapper._headerLeaveTimer = null;
    headerWrapper.addEventListener('mouseleave', (e) => {
      const relatedTarget = e.relatedTarget;
      if (relatedTarget && headerWrapper.contains(relatedTarget)) return;
      if (headerWrapper._headerLeaveTimer) clearTimeout(headerWrapper._headerLeaveTimer);
      headerWrapper._headerLeaveTimer = setTimeout(() => {
        document.querySelectorAll('header-menu').forEach((menu) => menu.close());
        headerWrapper._headerLeaveTimer = null;
      }, 900);
    });
    headerWrapper.addEventListener('mouseenter', () => {
      if (headerWrapper._headerLeaveTimer) {
        clearTimeout(headerWrapper._headerLeaveTimer);
        headerWrapper._headerLeaveTimer = null;
      }
    });
  }

  onMouseEnter() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    if (this.openTimer) {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }
    this.openTimer = setTimeout(() => {
      this.open();
      this.openTimer = null;
    }, this.openDelay);
  }

  onSummaryClick(event) {
    if (!event.target.closest(this.allowSummaryLinkSelector)) return;
    if (this.mainDetailsToggle.hasAttribute('open')) return;

    event.preventDefault();
    if (this.openTimer) {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }
    this.open();
  }

  onMouseLeave() {
    if (this.openTimer) {
      clearTimeout(this.openTimer);
      this.openTimer = null;
    }
    this.closeTimer = setTimeout(() => {
      this.close();
      this.closeTimer = null;
    }, this.hoverDelay);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
